import { Action, Module, VuexModule } from "vuex-module-decorators";
import { ExchangeStatus } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class ExchangeStatusModule extends VuexModule {
    @Action
    [ExchangeStatus.getExchangeStatusList]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/status/exchanges/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [ExchangeStatus.findPageExchangeStatus](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/status/exchanges`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [ExchangeStatus.saveExchangeStatus](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/status/exchanges/save`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

        @Action
    [ExchangeStatus.deleteExchangeStatus](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/status/exchanges/delete`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}